import CreateProject from 'viewmodel/CreateProjectViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesCreateProject extends DesBaseCollabAcc {

    constructor() {
        super(CreateProject);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id' ];
    }
}

if (!window.customElements.get('des-create-project')) {
    window.customElements.define('des-create-project', DesCreateProject);
}
